var $ = jQuery;

$(document).ready(function(){

    // accordions
    $('.landing_page_v3 .accordion__title').on("click", function(e){
        if($(this).parent().hasClass('active')){
            $('.landing_page_v3 .accordion__content').slideUp();
            $(this).parent().removeClass('active');
        }
        else{
            $('.landing_page_v3 .accordion__content').slideUp();
            $('.landing_page_v3 .accordion_single').removeClass('active');
            $(this).siblings('.accordion__content').slideDown();
            $(this).parent().addClass('active');
        }
    })
});